<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.4446 4.66667L6.33344 10.7778L3.55566 8.00001" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'check'
}
</script>



// WEBPACK FOOTER //
// src/ui/icon/Check.vue